import { render, staticRenderFns } from "./TextEditorFullview.vue?vue&type=template&id=30b9ea1f&scoped=true&lang=pug&"
import script from "./TextEditorFullview.vue?vue&type=script&lang=js&"
export * from "./TextEditorFullview.vue?vue&type=script&lang=js&"
import style0 from "./TextEditorFullview.vue?vue&type=style&index=0&id=30b9ea1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b9ea1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
